<div>
    <r1-compass-lib-instructions headerText="Salesforce Recommendation Target Objects">
        Select the Salesforce object for which Recommendations will be made and identify the Unique ID field to be used.
        At least one object must be chosen. Optionally, add additional Salesforce Target objects by clicking '+Add'.
        Users will select which Salesforce target to use at the Template Criteria level.
    </r1-compass-lib-instructions>
    @for (group of formArray.controls; track rowIndex; let rowIndex = $index) {
        <form [formGroup]="group">
            <r1-compass-lib-field-mapping
                [index]="rowIndex"
                [totalRequiredRows]="1"
                [rowOptionButtons]="[{ value: 'delete', display: 'Delete', show: true }]"
                (clickOption)="deleteMapperRow($event)">
                <r1-compass-lib-field-row [fieldRowWidth]="6">
                    <r1-compass-lib-field-field [fieldWidth]="2">
                        <mat-form-field>
                            <mat-label>Salesforce Target</mat-label>
                            <input matInput formControlName="name" />
                            @if (group.controls.name.errors?.['nameTaken']) {
                                <mat-error>Name taken</mat-error>
                            }
                        </mat-form-field>
                    </r1-compass-lib-field-field>

                    <r1-compass-lib-field-field [fieldWidth]="2">
                        <mat-form-field>
                            <mat-label>Source Unique ID</mat-label>
                            <mat-select formControlName="sourceField">
                                @for (field of formState.dataMartFields(); track $index) {
                                    <mat-option [value]="field.name"
                                        >{{ field.displayName }} ({{ field.name }})</mat-option
                                    >
                                }
                            </mat-select>
                            @if (group.controls.sourceField.errors?.['nameTaken']) {
                                <mat-error>Name taken</mat-error>
                            }
                            @if (group.controls.targetField.errors?.['required']) {
                                <mat-error>Value required</mat-error>
                            }
                        </mat-form-field>
                    </r1-compass-lib-field-field>

                    <r1-compass-lib-field-field [fieldWidth]="2">
                        <mat-form-field>
                            <mat-label>Target Unique ID</mat-label>
                            <mat-select formControlName="targetField">
                                @for (claim of claimsMapped(); track $index) {
                                    @if (claim.index === $index && claim.claimed) {
                                        <mat-option [value]="claim.field.name"
                                            >{{ claim.field.label }} ({{ claim.field.name }})</mat-option
                                        >
                                    } @else {
                                        <mat-option [value]="claim.field.name"
                                            >{{ claim.field.label }} ({{ claim.field.name }})</mat-option
                                        >
                                    }
                                }
                            </mat-select>
                            @if (group.controls.targetField.errors?.['nameTaken']) {
                                <mat-error>Name taken</mat-error>
                            }
                            @if (group.controls.targetField.errors?.['required']) {
                                <mat-error>Value required</mat-error>
                            }
                        </mat-form-field>
                    </r1-compass-lib-field-field>
                </r1-compass-lib-field-row>
            </r1-compass-lib-field-mapping>
        </form>
    }
    <button mat-raised-button color="primary" (click)="addMapperRow()" type="button">+Add</button>
</div>
